import { Button } from "@chakra-ui/button";
import { Input, InputGroup, InputRightElement } from "@chakra-ui/input";
import { Heading, Stack, Text } from "@chakra-ui/layout";
import { useToast } from "@chakra-ui/toast";
import React, { useState } from "react";
import axiosInstance from "../../helpers/axios";

function AddModelUse({ setModel, model }) {
  const [loading, setLoading] = useState();
  const [title, setTitle] = useState();
  const toast = useToast();

  function handleSubmit() {
    setLoading(true);
    if (!title) {
      toast({
        description: "Vehicle Use is required",
        status: "error",
        position: "top-right",
      });
      setLoading(false);
      return;
    }
    axiosInstance
      .post("/adduse", { title: title, id: model.type_id })
      .then((res) => {
        return res.data;
      })
      .then((res) => {
        if (res.error) {
          toast({
            description: res.message,
            status: "error",
            position: "top-right",
          });
        } else {
          setTitle("");
          toast({
            description: res.message,
            status: "success",
            position: "top-right",
          });
          setModel(res.data);
          //setModels(res.data);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }
  return (
    <Stack pt={10}>
      <Heading size={"md"}>
        <Text>Add Vehicle Use</Text>
      </Heading>
      <InputGroup size="md">
        <Input
          value={title}
          onChange={(e) => {
            setTitle(e.target.value);
          }}
          disabled={loading}
          pr="4.5rem"
          type="text"
          placeholder="Use Title"
        />
        <InputRightElement width="4.5rem">
          <Button
            h="1.75rem"
            size="sm"
            onClick={handleSubmit}
            isLoading={loading}
          >
            Add
          </Button>
        </InputRightElement>
      </InputGroup>
    </Stack>
  );
}

export default AddModelUse;
